export default "__VITE_ASSET__Cv30pFrN__"